import type { LoomExplicitTrimPreview } from "./loomExplicitTrimPreview";
import type { LoomProvisionalUnionPreview } from "./loomProvisionalUnionPreview";
import type { LoomOwnedDisplaySurface } from "./loomViewportPresentation";

type AvailableExplicitTrim = Extract<LoomExplicitTrimPreview, { kind: "available" }>;
type AvailableProvisional = Extract<LoomProvisionalUnionPreview, { kind: "available" }>;
const surfaceCache = new WeakMap<object, LoomOwnedDisplaySurface>();

function cachedSurface(source: object, create: () => LoomOwnedDisplaySurface): LoomOwnedDisplaySurface {
  const cached = surfaceCache.get(source);
  if (cached) return cached;
  const surface = create(); surfaceCache.set(source, surface); return surface;
}

export function selectLoomRetainedSurface(
  accepted: LoomOwnedDisplaySurface | null,
  phase: "transient" | "dirty" | undefined,
  explicit: AvailableExplicitTrim | null,
  provisional: AvailableProvisional | null,
): { accepted: boolean; surface: LoomOwnedDisplaySurface | null } {
  if (accepted && phase !== "transient") return { accepted: true, surface: accepted };
  if (explicit) return { accepted: false, surface: cachedSurface(explicit, () => ({
    faceEntityIds: explicit.faceEntityIds, faces: explicit.faces,
    geometrySource: "retained-display-faces", positions: explicit.positions,
  })) };
  if (provisional) return { accepted: false, surface: cachedSurface(provisional, () => ({
    faceEntityIds: Array.from(provisional.faceOperandIndices, (operand) => (
      provisional.sourceOperandIds[operand] ?? ""
    )),
    faces: provisional.faces, geometrySource: "retained-display-faces",
    positions: provisional.positions,
  })) };
  return { accepted: false, surface: null };
}
